<template>
  <div id="defaultNav">
    <div class="logo">
      <a href="#">
        <img src="@/assets/images/logodark.png" alt="corenroll-logo"
      /></a>
      <div class="appIcons"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header.vue",
};
</script>
